import type { TaskContext } from "../api/types";
import CategoryBadge from "./CategoryBadge";

// The operator-selected task for a recording — what the human said they were doing. Sits next to
// the Fraud check card (what the vision model saw) so reviewers can compare ground truth vs AI guess.
// Renders nothing when the recording has no task context (older recordings).
export default function TaskCard({ task }: { task: TaskContext | null | undefined }) {
  if (!task || (!task.title && !task.category && !task.description)) return null;
  return (
    <section className="card task-card">
      <div className="card-head">
        <h3>Task</h3>
        <CategoryBadge task={task} />
      </div>
      {task.title && <p className="task-title">{task.title}</p>}
      {task.description && <p className="task-desc muted small">{task.description}</p>}
    </section>
  );
}
